/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PointsFigureUnit } from './pointsFigureUnit';
import type { PointsFigureAxis } from './pointsFigureAxis';
import type { Point } from './point';
import type { Extras } from './extras';

export interface PointsFigure {
  name: string;
  shape: 'points';
  unit: PointsFigureUnit;
  axis: PointsFigureAxis;
  value: Point[];
  extras: Extras;
}
